import {createApp} from 'vue'


const privaccept = createApp({
    data() {
        return {
            privaccepted:false
        }
    },

    methods: {

        onSubmit: function() {
            this.$refs.privform.submit()
        }
    },

})

if (document.getElementById('privaccept')) {
    privaccept.mount('#privaccept')
}


